module.exports = __webpack_public_path__ + "img/Photo_2__West_Street_2010_3_434.32b5c30d.jpg";